import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";

export const complaintApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getComplaints: builder.query<any, PaginateQuery>({
      query: (data) => ({
        url: buildPaginationQueryString(data, "/api/complaint"),
      }),
      providesTags: ["Complaint"],
    }),
  }),
});

export const { useGetComplaintsQuery } = complaintApi;
